import { render, staticRenderFns } from "./quotationDetail.vue?vue&type=template&id=0a4a430a&scoped=true&"
import script from "./quotationDetail.vue?vue&type=script&lang=js&"
export * from "./quotationDetail.vue?vue&type=script&lang=js&"
import style0 from "./quotationDetail.vue?vue&type=style&index=0&id=0a4a430a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4a430a",
  null
  
)

export default component.exports